import { render } from "./TheDetailsGallery.vue?vue&type=template&id=e4e1433e&scoped=true"
import script from "./TheDetailsGallery.vue?vue&type=script&lang=js"
export * from "./TheDetailsGallery.vue?vue&type=script&lang=js"

import "./TheDetailsGallery.vue?vue&type=style&index=0&id=e4e1433e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e1433e"]])

export default __exports__